export default "__VITE_ASSET__DW$R0Gtb__"